import { subYears, subMonths, addYears } from 'date-fns'
import type { CofidisMonthlyApplicationFormValues } from './types'

const now = new Date()
const today = new Date(now.getFullYear(), now.getMonth(), now.getDate())

/** Valid mock form values for DEV fill-section. Dates are Date objects; opt-ins are booleans. */
export const cofidisMockFormValues: CofidisMonthlyApplicationFormValues = {
  // Identity & contact
  title: '1',
  firstName: 'Dev',
  lastName1: 'User',
  lastName2: 'Test',
  idType: 'NIE',
  idNumber: 'X1234567L',
  idCessationOfValidityDate: addYears(today, 5),
  nationality: 'ES',
  birthDate: subYears(today, 30),
  birthCountry: 'ES',
  birthTown: 'Madrid',
  familySituation: 'S',
  childSupportNumber: '0',
  email: 'dev@example.com',
  sustainableSupport: 'E',
  phoneNumber: '600000000',
  phoneNumber2: '',
  // Residence
  wayType: 'CL',
  wayDescription: 'Mayor',
  wayNumber: '1',
  floor: '2',
  letter: 'A',
  additionalAddress: '',
  zipCode: '28001',
  town: 'Madrid',
  country: 'ES',
  homeType: 'L',
  homeExpenses: '500',
  entranceDate: subYears(today, 5).getFullYear().toString(),
  // Employment (professionCode 30 = privateSectorExecutive, requires salary/contractType/contractStartDate)
  professionCode: '30',
  contractType: 'CDI',
  contractStartDate: subYears(today, 2),
  contractEndDate: undefined,
  salary: '25000.50',
  salaryMonthsNumber: '14',
  companyName: 'Acme SL',
  // companyId: 'B12345678',
  companyWayType: 'CL',
  companyWayDescription: 'Gran Vía',
  companyWayNumber: '100',
  companyZipCode: '28013',
  companyTown: 'Madrid',
  companyPhone: '912345678',
  // Bank (valid Spanish IBAN)
  iban: 'ES9121000418450200051332',
  bankAccountHolderName: 'Dev User Test',
  bankAccountOpeningDate: subYears(today, 3),
  editionMode: 'D',
  // Terms
  vedaconAcceptance: true,
  internalOptin: true,
  partnerOptin: false,
}
